export default (api, resource) => ({

    getAll: async ({ params, token }) => {
        const response = await api.get(`/${resource}`, {
            params,
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    getById: async ({ id, token }) => {
        const response = await api.get(`/${resource}/${id}`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    /*
      Diz se o ponto pode receber pix agora (configuracao ativa, hub configurado,
      estabelecimento operando). Nunca devolve erro: quando nao da, vem false.
    */
    disponivel: async ({ estabelecimentoId, token }) => {
        const response = await api.get(`/${resource}/disponivel`, {
            params: { estabelecimento_id: estabelecimentoId },
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    /*
      Quais estabelecimentos da lista aceitam pix agora -- uma chamada para a
      listagem inteira, no lugar de uma por linha.
    */
    disponiveis: async ({ estabelecimentoIds, token }) => {
        const response = await api.get(`/${resource}/disponiveis`, {
            params: { estabelecimento_ids: estabelecimentoIds.join(',') },
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    gerarPix: async ({ estabelecimentoId, valor, cpf, token }) => {
        const response = await api.post(`/${resource}/pix`, {
            estabelecimentoId,
            valor,
            cpf
        }, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    // Mesmo payload do getById, usado no acompanhamento da cobranca aberta.
    consultarStatus: async ({ id, token }) => {
        const response = await api.get(`/${resource}/${id}/status`, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    },

    cancelar: async ({ id, token }) => {
        const response = await api.put(`/${resource}/${id}/cancelar`, {}, {
            headers: { Authorization: token }
        })
        return { data: response.data }
    }
})
